import type { RouteObject } from "react-router";
import { CustomerList } from "./CustomerList";

export const customerRoute: RouteObject = {
  path: "customer",
  element: <CustomerList />,
};
